import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'reactstrap';

import { callApi } from '../../utils';
import { showError, showInfo } from '../../actions/notificationActions';

import Loading from '../Loading';
import DataTable from '../DataTable';

class UserVirtualAccounts extends React.Component {
  state = {
    queryParams: {
      page: 1,
      limit: '30',
    },
    pages: 1,
    meta: { pages: 1 },
    loading: false,
    rows: [],
    users: [],
    revokeLoading: false,
  };

  setInput = (e) => {
    const { name, value } = e.target;
    this.setState({
      queryParams: { ...this.state.queryParams, [name]: value },
    });
  };

  setPage = (page) => {
    if (page) {
      this.setState(
        { queryParams: { ...this.state.queryParams, page } },
        () => {
          this.loadGrants();
        }
      );
    }
  };

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  loadGrants = () => {
    const { page, limit } = this.state.queryParams;
    const id = this.props.user.id;
    this.setState({ loading: true });
    callApi(`/users/${id}/facility-grants?limit=${limit}&page=${page}`)
      .then(({ data = [], meta = {} }) => {
        console.log('Data', data);
        this.setState({ loading: false });
        this.setState({ rows: data, meta });
      })
      .catch((err) => {
        this.setState({ loading: false });
        this.props.dispatch(showError(err));
      });
  };

  refreshTable = (data) => {
    this.setState({ rows: [...this.state.rows, data] });
  };

  componentWillMount() {
    this.loadGrants();
  }

  view = (id) => {
    // Implement a display modal
    // this.props.dispatch()
  };

  revoke = (user_id, grant_id) => {
    this.setState({ revokeLoading: true });

    callApi(`/users/${user_id}/facility-grants/${grant_id}`, {}, 'delete')
      .then((response) => {
        this.setState({ revokeLoading: false });
        this.props.dispatch(showInfo(response.message));
        this.loadGrants();
      })
      .catch((err) => {
        this.setState({ revokeLoading: false });
        this.props.dispatch(showError(err));
      });
  };

  render() {
    const { rows, queryParams, loading, meta } = this.state;

    return (
      <div>
        {/* <CreateVirtualAcctModal refresh={this.refreshTable} /> */}
        <Row>
          <Col md="12" xs={12}>
            <div className="mt-10">
              {loading ? (
                <Loading />
              ) : (
                <div>
                  <DataTable
                    card={false}
                    loading={loading}
                    minWidth={700}
                    page={queryParams.page}
                    total={meta.pages || 1}
                    onPageChange={this.setPage}
                  >
                    <thead className="text-primary">
                      <tr>
                        <th>No.</th>
                        {/* <th>Acc. Number</th> */}
                        <th>Meter</th>
                        <th>Acc Name</th>
                        <th>Asset Provider</th>
                        <th>Service Provider</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Revoke</th>
                      </tr>
                    </thead>

                    <tbody>
                      {rows.map((t, i) => {
                        // const user = users.find((u) => u.id == t.generatedBy) || {};
                        return (
                          <tr onClick={() => this.view(t.id)} key={t.id}>
                            <td>
                              {loading
                                ? 'x'
                                : i +
                                  1 +
                                  (queryParams.page - 1) * queryParams.limit}
                            </td>
                            {/* <td>{t.acc_num}</td> */}
                            <td>{t.facility.reference}</td>
                            <td>{t.facility.owner}</td>
                            <td>{t.facility.asset_provider}</td>
                            <td>{t.facility.service_provider}</td>
                            <td>{t.facility.type}</td>
                            <td>{t.status}</td>
                            <td>
                              {' '}
                              <Button
                                size="sm"
                                disabled={
                                  t.status === 'APPROVED' ? false : true
                                }
                                color={'primary'}
                                onClick={() => this.revoke(t.user_id, t.id)}
                              >
                                {'Revoke'}
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </DataTable>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(UserVirtualAccounts);
